export default __webpack_public_path__ + "static/media/Art_Wall_img.6aef360a.png";